<template>
  <div
    class="btn main filled"
    :class="{ disabled }"
    @click="$emit('click')"
    @mousedown="$emit('mousedown')"
    @mouseup="$emit('mouseup')"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style scoped>
.main.btn.filled:hover {
  background-color: var(--color-darker-main);
}
.main.btn.filled {
  background-color: var(--color-main);
  color: var(--color-white);
  font-weight: 600;
}
</style>

<style scoped src="./btn/shared.css"></style>
<style scoped src="./btn/shared_gt_768.css"></style>
<style scoped src="./btn/shared_gt_375.css"></style>
<style src="./btn/unscopedShared.css"></style>
<style src="./btn/unscopedShared375.css"></style>
